<template>
  <b-container variant='light'>
    <b-container>
        <b-row>
            <b-col class="col-xs-12 col-md-6">
                <b-list-group-item variant="info">
                    <h3>Propositions</h3>
                    <draggable v-model="answers" group="answers" class="drop-zone" @start="drag=true" @end="drag=false">
                        <b-list-group-item variant="primary" class="draggable" v-for="answer in answers" :key="answer.id">{{answer.answer_value}}</b-list-group-item>
                    </draggable>     
                </b-list-group-item>   
            </b-col>
            <b-col class="col-xs-12 col-md-6">
                <b-list-group-item variant="info">
                    <h3>Vos réponses</h3>
                    <i v-if="expectedNbResponses!=null">
                        Veuillez glisser-déposer ci-dessous
                        <span v-if="expectedNbResponses==1">la bonne réponse</span>
                        <span v-else-if="expectedNbResponses>1">les {{expectedNbResponses}} bonnes réponses</span>
                    </i>
                    <draggable v-model="userAnswers" group="answers" :class="draggableStyle" ghost-class="ghost" @start="drag=true" @end="drag=false">
                        <b-list-group-item variant="primary" class="draggable" v-for="answer in userAnswers" :key="answer.id">{{answer.answer_value}}</b-list-group-item>
                    </draggable>       
                </b-list-group-item>   
            </b-col>
        </b-row>
    </b-container>
  </b-container>
</template>

<script>
import draggable from 'vuedraggable'
export default {
    data () {
        return {
            answers : [],
            userAnswers : [],
            expectedNbResponses: null
        }
    },
    computed: {
        selected () {
            if (this.userAnswers.length >= 1 && this.userAnswers.length <= 4) {
                let selected = ''
                this.userAnswers.forEach((el, index) => {
                    selected += el.id
                    if(index+1 < this.userAnswers.length) {
                        selected += ' '
                    }
                })
                return selected
            }
            else {return null}
        },
        draggableStyle () {
            if (this.selected === null) {
                return "empty-list"
            }
            else {
                return "drop-zone"
            }
        }
    },
    mounted() {
        this.answers = this.question.answers
        this.expectedNbResponses = this.answers.filter(a => a.is_correct==true).length;
    },
    components: {
        draggable,
    },
    props: {
        question: Object,
    },
  watch: {
    selected: function() {
        this.$emit('update-selected', this.selected)
    },
    question: function() {
        this.answers = this.question.answers;
        this.userAnswers = [];
    },
  },
}
</script>

<style scoped>
h3 {
    width: 100%;
    border-bottom: 1px solid
}
.draggable, .draggable:hover {
    cursor: grab;
}
.drop-zone {
    min-height: 30px;
}
.list-group-item {
    padding-left: 10px;
    padding-right: 10px;
}
.empty-list {
    border: 2px dashed #bbb;
    min-height: 45px;
    background-color: #b8c8d7;
}
.ghost {
    z-index: 2
}
i {
    font-size: 0.8rem;
}
</style>